import styled from 'styled-components';
import { motion } from 'framer-motion';

import background from '../../assets/images/backoffice/auth-back.jpg';
import background2 from '../../assets/images/backoffice/auth-back-2.jpg';

export const Layout = styled(motion.div)`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  flex-direction: column;
  background: url(${background2});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 40px 0;
`;

export const Main = styled.div`
  width: 500px;
  margin: 30px auto;
  padding: 50px 32px;
  background: ${({ theme }) => theme.colors.neutral0};
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 1450px) {
    margin: 10px auto;
  }

  @media (max-width: 1000px) {
    max-width: calc(100% - 32px);
    padding: 20px;
  }
`;
